import { SvgIconProps } from '@mui/material';

export const FeaturedResumeIcon = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#F5F5FF" r="28" />
      <circle cx="28" cy="28" fill="#E7E7FC" r="20" />
      <path
        d="M22 22L27 27L22 32M29 22L34 27L29 32"
        stroke="#0B0BCF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
